import type {
  SystemScenarioDefinition,
  SystemScenarioHandler,
  SystemScenarioRegistration,
} from './SystemWorkspaceContracts';

const registrations = new Map<
  string,
  SystemScenarioRegistration
>();

function registrationKey(
  systemId: string,
  scenarioId: string,
): string {
  return `${systemId}:${scenarioId}`;
}

export function registerSystemScenario(
  scenario: SystemScenarioDefinition,
  handler: SystemScenarioHandler,
): void {
  if (scenario.id !== handler.scenarioId) {
    throw new Error(
      'Scenario and handler IDs do not agree.',
    );
  }

  if (scenario.systemId !== handler.systemId) {
    throw new Error(
      'Scenario and handler system authority do not agree.',
    );
  }

  const key = registrationKey(
    scenario.systemId,
    scenario.id,
  );

  if (registrations.has(key)) {
    throw new Error(
      `System scenario already registered: ${key}`,
    );
  }

  registrations.set(key, {
    scenario,
    handler,
  });
}

export function getSystemScenarioRegistration(
  systemId: string,
  scenarioId: string,
): SystemScenarioRegistration | null {
  return (
    registrations.get(
      registrationKey(systemId, scenarioId),
    ) ?? null
  );
}

export function listSystemScenarioRegistrations(
  systemId?: string,
): SystemScenarioRegistration[] {
  const values = [
    ...registrations.values(),
  ];

  if (!systemId) {
    return values;
  }

  return values.filter(
    registration =>
      registration.scenario.systemId ===
      systemId,
  );
}

export function hasSystemScenarioRegistration(
  systemId: string,
  scenarioId: string,
): boolean {
  return registrations.has(
    registrationKey(systemId, scenarioId),
  );
}

export function clearSystemScenarioRegistryForTests():
  void {
  registrations.clear();
}
